import "./ReviewForm.scss";
import { useState } from "react";
import axios from "axios";
import { API_URL } from "../../utils/axios";

const ReviewForn = ({ fetchAll }) => {
  const [name, setName] = useState("");
  const [review, setReview] = useState("");

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleReviewChange = (e) => {
    setReview(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    axios
      .post(API_URL + "/review", {
        review_name: name,
        review_description: review,
      })
      .then((response) => {
        setName("");
        setReview("");
        fetchAll();
      })
      .catch((error) => console.log(error));
  };

  return (
    <form className="review-form" onSubmit={handleSubmit}>
      <label htmlFor="name" className="review-form__label">
        NAME
      </label>
      <input
        type="name"
        id="name"
        name="name"
        placeholder="Name"
        className=" review-form__input"
        value={name}
        onChange={handleNameChange}
      />
      <label htmlFor="review" className="review-form__label">
        REVIEW
      </label>
      <textarea
        id="review"
        name="review"
        placeholder="Write your review here"
        className="review-form__text"
        value={review}
        onChange={handleReviewChange}
      ></textarea>
      <button className="review-form__button">SUBMIT</button>
    </form>
  );
};

export default ReviewForn;
